import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as AOS from 'aos';

declare let $: any;

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });

    this.initCounters();
  }

  ngAfterViewInit(): void {
    this.initPartnerSlider();
  }

  private initPartnerSlider(): void {
    setTimeout(() => {
      if (typeof $ === 'undefined') {
        return;
      }

      const $partnerSlider = $('.partner-slider');

      if (!$partnerSlider.length) {
        return;
      }

      if ($partnerSlider.hasClass('owl-loaded')) {
        $partnerSlider.trigger('destroy.owl.carousel');
        $partnerSlider.removeClass('owl-loaded owl-hidden');
        $partnerSlider.find('.owl-stage-outer').children().unwrap();
      }

      $partnerSlider.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        autoplay: true,
        smartSpeed: 800,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 1
          },
          576: {
            items: 2
          },
          768: {
            items: 3
          },
          992: {
            items: 4
          },
          1200: {
            items: 5
          }
        }
      });
    }, 150);
  }

  private initCounters(): void {
    const counters = document.querySelectorAll('.counter');

    const observerOptions = {
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const counter = entry.target as HTMLElement;
          const target = parseInt(counter.getAttribute('data-count') || '0', 10);
          this.animateCounter(counter, target);
          observer.unobserve(counter);
        }
      });
    }, observerOptions);

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  }

  private animateCounter(element: HTMLElement, target: number): void {
    const duration = 2000;
    const startTime = performance.now();
    const startValue = 0;

    const updateCounter = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.floor(startValue + (target - startValue) * easeOutQuart);

      element.textContent = currentValue.toString();

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        element.textContent = target.toString();
      }
    };

    requestAnimationFrame(updateCounter);
  }
}
